export default "__VITE_ASSET__B0rEB6Rx__"